import React from 'react';
import { Route, Routes, Outlet, Navigate } from 'react-router-dom';
import UsageStatsView from '@dashboard/views/UsageStatsView/UsageStatsView';
import UserProfileView from '@dashboard/views/UserProfileView/UserProfileView';
import ResultsStatsView from '@dashboard/views/ResultsStatsView/ResultsStatsView';
import AnalysisStatsView from '@dashboard/views/AnalysisStatsView/AnalysisStatsView';
import IdentificationStatsView from '@dashboard/views/IdentificationStatsView/IdentificationStatsView';
import CentersView from '@dashboard/views/CentersView/CentersView';
import UserListView from '@dashboard/views/UserListView/UserListView';
import UserEditView from '@dashboard/views/UserEditView/UserEditView';
import SyncMonitorView from '@dashboard/views/SyncMonitorView/SyncMonitorView';
import { useAuth } from '@auth/hooks';
import { useCanViewIdentificationStats } from '@app/hooks/useCanViewIdentificationStats';

export default function DashboardRoutes() {
  const { user } = useAuth();
  const canViewSyncMonitor = user?.role?.name === 'datalab-administrator';
  const canViewIdentificationStats = useCanViewIdentificationStats();

  return (
    <div>
      <Outlet />

      <Routes>
        <Route path="data">
          <Route index path="usage" element={<UsageStatsView />} />
          <Route index path="results" element={<ResultsStatsView />} />
        </Route>
        <Route path="neuro">
          <Route index path="analysis" element={<AnalysisStatsView />} />
          <Route
            index
            path="identification"
            element={
              canViewIdentificationStats ? (
                <IdentificationStatsView />
              ) : (
                <Navigate to="centers" replace />
              )
            }
          />
        </Route>
        <Route index path="user/profile" element={<UserProfileView />} />
        <Route index path="centers" element={<CentersView />} />
        <Route index path="users" element={<UserListView />} />
        <Route index path="users/:uuid" element={<UserEditView />} />
        <Route
          index
          path="sync-monitor"
          element={
            canViewSyncMonitor ? (
              <SyncMonitorView />
            ) : (
              <Navigate to="centers" replace />
            )
          }
        />
        <Route path="*" element={<Navigate to="centers" replace />} />
      </Routes>
    </div>
  );
}
